import { moduleIterator } from '../moduleUtils';

moduleIterator(require.context('@/plugins', false, /\.js$/));
